import { Box, Button, CircularProgress, Radio } from '@mui/material';
import React from 'react'
import { useState, Downgraded } from '@hookstate/core';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import Helper from '../../utility/helper';
import { updateModuleState, useEventState } from '../../stores/eventStore';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import {
    generatePath,
    // useParams,
    useHistory
} from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import { useEffect } from 'react';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import SocialMasters from './socialMasters';
import Title from '../../sharedcomponents/title/title';

import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { makeStyles } from '@mui/styles';
import AppConstants from '../../constants/appConstants';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const SocialResponsibility = (props) => {
    const classes = useStyles();
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const loading = useState(false);
    const btnLoading = useState(false);
    const [showDetailData, setShowDetailData] = React.useState('');
    const eventState = useEventState()
    const [participant, setParticipant] = React.useState(null);
    const [participantList, setParticipantList] = React.useState(null);
    const history = useHistory()
    const [showDetails, setShowDetails] = React.useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const [hideSubmitButton, setHideSubmitButton] = React.useState(true);
    const [mastersData, setMastersData] = React.useState();
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [socialData, setSocialData] = React.useState();

    useEffect(() => {
        console.log("history.location.state", history.location.state);
        if (history.location.state && history.location.state.FilteredParticpants != null) {
            setParticipantList(history.location.state.FilteredParticpants)
        } else {
            getParticipantList();
            // GetAdminEventParticipant(gEventInfo, gUserInfo, gUserInfo.userID);
        }
        if (userInfo && !(Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)))) {
            if (history.location.state && history.location.state.FilteredParticpants == null) {
                GetSocialResposibilityData(userInfo);
            }
        }
        setHideSubmitButton(true)
        return () => {
            // setSelectedPreferenceCount(0)
        };

    }, []);
    // useEffect(() => {
    //     if (history.location.state && history.location.state.socialResponsibilityState != null) {
    //         const socialInfo = history.location.state.socialResponsibilityState;
    //         const index = participantList && participantList.findIndex(
    //             (user) => user.userID == socialInfo.userID
    //         );
    //         if (index && index > -1) {
    //             setParticipant(participantList[index]);
    //             changeParticipant(participantList[index])
    //         }
    //     }
    // }, [participantList])
    const GetSocialResposibilityData = (participant) => {
        // console.log("participant", participant);
        loading.set(true);
        if (participant) {
            const eventInfo = Helper.getStorage('eventInfo');
            const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
            const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');

            ApiHelper.get(
                APIURLConstants.GET_SOCIAL_RESPONSIBILITY(
                    eventInfo.eventID,
                    ((Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) ?
                        (history.location.state && history.location.state.socialResponsibilityState != null ?
                            history.location.state.socialResponsibilityState.userID :
                            participant.userID) :
                        participant.userID),
                    14
                )
            )
                .then((res) => {
                    let newData = res.data;
                    loading.set(false);
                    if (newData.length > 0) {
                        let newGetData = []
                        newData.map((val) => {
                            if (participant.tags) {
                                let splitUserInfoTags = []
                                if (participant.tags.length > 0) {
                                    participant.tags.map((val) => {
                                        if (val.eventID == eventInfo.eventID) {
                                            splitUserInfoTags.push(val.userTags)
                                        }
                                    })
                                }
                                // console.log("splitUserInfoTags", splitUserInfoTags);
                                const splitTags = splitUserInfoTags && splitUserInfoTags.length > 0 ? splitUserInfoTags.toString().split(',') : [];
                                // console.log("splitTags", splitTags);
                                if (splitTags && splitTags.length > 0) {
                                    // console.log("into if");
                                    splitTags.map((vals) => {
                                        // console.log("val",val);
                                        const match = val.tagIDs.trim().match(vals.trim());
                                        if (match !== null) {
                                            newGetData.push(val)
                                            return;
                                        }
                                    })
                                } else {
                                    // console.log("into else");
                                    newGetData = []
                                }
                            } else {
                                // console.log("into motha else");
                                const splitTags = participant.userTags && participant.userTags.split(',');
                                if (splitTags && splitTags.length > 0) {
                                    splitTags.map((vals) => {
                                        // console.log("val",val);
                                        const match = val.tagIDs.trim().match(vals.trim());
                                        if (match !== null) {
                                            newGetData.push(val)
                                            return;
                                        }
                                    })
                                }
                            }
                        })
                        // console.log("newGetData", newGetData);
                        let uniq = {};
                        let output = newGetData.filter(obj => !uniq[obj.masterID] && (uniq[obj.masterID] = true));
                        // console.table("output", output);
                        setSocialData(output)
                    }
                }).catch((err) => {
                    console.log(err);
                    loading.set(false);
                })
        }

    }

    const getParticipantList = () => {
        const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
        const gUserInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
        const gEventInfo = Helper.getStorage('eventInfo');
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                    if (history.location.state && history.location.state.socialResponsibilityState != null) {
                        const socialInfo = history.location.state.socialResponsibilityState;
                        const index = participants && participants.findIndex(
                            (user) => user.userID == socialInfo.userID
                        );
                        participants && participants.map((val) => {
                            if (val.userID == socialInfo.userID) {
                                setParticipant(val);
                                changeParticipant(val)
                            }
                        })
                        console.log("index", index);
                        // if (index && index > -1) {
                        //     setParticipant(participantList[index]);
                        //     // changeParticipant(participantList[index])
                        // }
                    }


                }
            });
        }
    };
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState.get() && eventState.eventDetail.get() != null) {
            const index = eventState.eventDetail
                .get()
                .moduleDetails?.findIndex((element) => {
                    if (element.moduleName === 'SocialResponsibility') {
                        return true;
                    }
                });
            // if (!Helper.isAdminUser(userInfo)) {
                if (
                    eventState.eventDetail.get() &&
                    ((index > 0 &&
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== null) ||
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== '')
                ) {
                    setShowDetails(true);
                    setShowDetailData(
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details
                    );
                } else {
                    setShowDetails(false);
                    setShowDetailData('');
                }
            // }
        }
        if (!Helper.isAdminUser(userInfo) || !Helper.isEventAdmin(userInfo)) {
            let modulePermission = eventState.attach(Downgraded).get().permissions &&
                eventState.attach(Downgraded).get().permissions.length > 0 && eventState.attach(Downgraded).get().permissions.filter(item => item.module === "SOCIALRESPONSIBILITY");
            if (modulePermission != undefined && modulePermission.length > 0 && modulePermission[0].permission === "VIEW") {
                setModPermission(VIEW_PERMISSION);
            } else {
                setModPermission(FULL_PERMISSION)
            }
        }
        else {
            setModPermission(FULL_PERMISSION);
        }
    }, [eventState])
    const changeParticipant = (participant) => {
        // console.log("participant", participant);
        setParticipant(participant);
        GetSocialResposibilityData(participant)
    }
    const handleRadioChange = () => {
        setHideSubmitButton(false)
    }

    const onMasterchange = (masterID, serviceRequest) => {
        let newMasterData;
        let selectedData = socialData ? socialData.find(i => i.masterID === parseInt(masterID)) : null;
        if (selectedData) {
            newMasterData = [{
                socialResponsibilityID: selectedData.socialResponsibilityID,
                masterID: selectedData.masterID,
                preference: selectedData.preference,
                specialRequest: serviceRequest,
                createdBy: userInfo.userID,
                isRequestTimeSlot: selectedData.isRequestTimeSlot
            }]

            setMastersData(newMasterData)
            setHideSubmitButton(false)
        }
        else {
            setMastersData([]);
        }
    }
    // console.log("hideSubmitButton",hideSubmitButton);
    const handleSubmit = () => {
        if (!mastersData) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please Enter Requested Timeslot',
            });
            return;
        } else if (mastersData && mastersData.length > 0) {
            mastersData.map((val) => {
                if (!val.specialRequest && val.isRequestTimeSlot) {
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Please Enter Requested Timeslot',
                    });
                    return false;
                } else {
                    const postData = {
                        userID: participant ? participant.userID : userInfo.userID,
                        eventID: eventInfo.eventID,
                        masters: mastersData,
                    };

                    // console.log("postData", postData);
                    btnLoading.set(true)
                    ApiHelper.post(
                        APIURLConstants.ADD_UPDATE_SOCIAL_RESPONSIBILITY,
                        postData
                    ).then((res) => {
                        if (res.data) {
                            btnLoading.set(false)
                            GetSocialResposibilityData(participant ? participant : userInfo);
                            updateModuleState()
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: 'Request posted successfully',
                            });
                            setHideSubmitButton(true)
                            setTimeout(() => {
                                if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
                                    history.push(generatePath(RouteConstants.EVENT_SOCIAL_RESPONSIBILITY, { eventID: eventInfo.eventID }))
                                }
                            }, 1000)
                        }
                    }).catch((err) => {
                        console.log(err);
                        btnLoading.set(false)
                    });
                }
            })
        }
    }
    const handleClose = () => {
        if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
            history.push(generatePath(RouteConstants.EVENT_SOCIAL_RESPONSIBILITY, { eventID: eventInfo.eventID }))
        } else {
            history.goBack()
        }
    }
    return (
        <Box className={loading.get() ? 'alignCenter' : 'otherContentBox'}
            sx={{
                overflow: 'auto',
                maxHeight: 'calc(100vh - 70px)',
            }}
        >
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Box sx={{ p: 1 }}>
                        <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [], AppConstants.EVENT_MODULES.SOCIAL_RESPONSIBILITY)} />
                        {showDetails ? (
                            <DetailsComponent data={showDetailData} />
                        ) : null}
                    </Box>
                    <Box>
                        {participantList && (
                            <Box
                                sx={{
                                    width: ' 30%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 0.3,
                                    justifyContent: 'center',
                                    mx: 'auto',
                                    mb: 1
                                    // '& .MuiFormControl-root': { width: '100%' },
                                }}>
                                <ParticipantAutoList
                                    disableParticipant={
                                        history.location.state && history.location.state.socialResponsibilityState
                                            ? true
                                            : false
                                    }
                                    participant={participant}
                                    setParticipant={changeParticipant}
                                    participantList={participantList}
                                    modPermission={modPermission}

                                />
                            </Box>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        <SocialMasters
                            socialData={socialData}
                            historyData={history.location.state && history.location.state.socialResponsibilityState}
                            onMasterchange={onMasterchange}
                            handleRadioChange={handleRadioChange}
                        />
                    </Box>
                    <Box>
                        <ButtonContainer
                            showLoading={btnLoading.get()}
                            loading={btnLoading.get()}
                            disableCancel={false}
                            disableButton={(Helper.isAdminUser(userInfo) ||
                                (userInfo.roles && Helper.isEventAdmin(userInfo))) ? hideSubmitButton :
                                (eventInfo.readonlyOrHide === 1 ? true :
                                    modPermission === VIEW_PERMISSION ? true : hideSubmitButton)}
                            handleClick={handleSubmit}
                            handleCancel={handleClose}
                            buttonText={history.location.state && history.location.state.socialResponsibilityState && history.location.state.socialResponsibilityState.requestStatus.toLowerCase() === "pending" ? 'Update & Submit' : 'SUBMIT'}
                        />
                    </Box>
                </>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </Box>

    )
}
export default {
    routeProps: {
        path:
            RouteConstants.SOCIAL_RESPONSIBILITY,
        component: SocialResponsibility,
    },
    name: 'SocialResponsibility',
};